import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event: InputEvent) {
    const showAvatar = (event.currentTarget as HTMLInputElement).checked

    const shadowPages = document.querySelectorAll<HTMLElement>(
      "[data-slide-type='about-me'] shadow-page",
    )
    if (shadowPages.length === 0) return

    const lastShadowPage = shadowPages[shadowPages.length - 1]
    const shadowRoot = lastShadowPage.shadowRoot
    if (!shadowRoot) return

    const avatar = shadowRoot.querySelector<HTMLElement>("#design_avatar")
    const image = shadowRoot.querySelector<HTMLElement>("#design_image")
    if (!avatar || !image) return

    const avatarPhotos = shadowRoot.querySelectorAll<HTMLElement>(
      ".avatar__photo.avatar__photo-position",
    )

    if (showAvatar) {
      avatar.className = "flex justify-content-center align-items-center relative"
      image.className = "hidden"
      avatarPhotos.forEach((photo) => {
        photo.style.display = ""
      })
    } else {
      avatar.className = "hidden"
      image.className = "flex justify-content-center align-items-center relative"
      avatarPhotos.forEach((photo) => {
        photo.style.display = "none"
      })
    }
  }
}
